// extracted by mini-css-extract-plugin
export default {"LoadingContainer":"B8zUXPaP","MedicalClaimsPanelContainer":"BpVZFnXP","MedicalClaimsProviderContainer":"v7o22jht"};